/**
 * components/sparkline.tsx — a tiny trend line (Rules list 72×22, Perf 56×20).
 */
import React from 'react';
import { Platform } from 'react-native';
import { LightColors as C } from '../theme/theme';
import { sparkPath } from '../lib/spark';

export interface SparklineProps {
  data: number[] | null;
  width?: number;
  height?: number;
  stroke?: string;
  strokeWidth?: number;
}

const Sparkline: React.FC<SparklineProps> = ({
  data,
  width = 72,
  height = 22,
  stroke = C.ink2,
  strokeWidth = 1.6,
}) => {
  const d = sparkPath(data, width, height);

  if (Platform.OS === 'web') {
    return (
      <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} style={{ overflow: 'visible' }}>
        <path d={d} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const { default: Svg, Path } = require('react-native-svg');
  return (
    <Svg width={width} height={height} viewBox={`0 0 ${width} ${height}`}>
      <Path d={d} fill="none" stroke={stroke} strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" />
    </Svg>
  );
};

export default Sparkline;
